/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Hero_EyebrowInputs */

const en_fw_hero_eyebrow = /** @type {(inputs: Fw_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Firefly Wedding anime fan hub`)
};

const zh_fw_hero_eyebrow = /** @type {(inputs: Fw_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画粉丝资讯站`)
};

/**
* | output |
* | --- |
* | "The Firefly Wedding anime fan hub" |
*
* @param {Fw_Hero_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_hero_eyebrow = /** @type {((inputs?: Fw_Hero_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Hero_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_hero_eyebrow(inputs)
	return zh_fw_hero_eyebrow(inputs)
});
export { fw_hero_eyebrow as "fw.hero.eyebrow" }